module.exports = __webpack_public_path__ + "static/media/photography09.7e931017.png";